import { render } from "./index.vue?vue&type=template&id=02839f35&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=02839f35&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02839f35"],['__file',"src/vab/layouts/VabLayoutFloat/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02839f35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02839f35', __exports__)) {
    api.reload('02839f35', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=02839f35&scoped=true", () => {
    api.rerender('02839f35', render)
  })

}


export default __exports__